/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Properties of the original Azure DB at the time the snapshot was taken. Present only when `resourceType` is set to `AZURE_VIRTUAL_MACHINE`. 
*/
export class AzureMssqlSnapshotProperties {
  /**
  * The sku of the resource
  */
  'sku'?: string;
  /**
  * The admin login of the resource
  */
  'adminLogin'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "sku",
      "baseName": "sku",
      "type": "string",
      "format": ""
    },
    {
      "name": "adminLogin",
      "baseName": "adminLogin",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AzureMssqlSnapshotProperties.attributeTypeMap;
  }

  public constructor() {
  }
}

